import { IScenarioState } from "./Scenario";

export class Assert {
    static exists(v: any, message: string) {
        if (v === undefined || v === null) {
            console.log("WARNING: asserted not exists, " + message + "\n\tActual: " + v);
        }
    }
    static areEqual(expected: number, actual: number, message: string) {
        if (expected !== actual) {
            console.log("WARNING: asserted not equal, " + message + "\n\tExpected: " + expected + "\n\tActual: " + actual);
        }
    }
}
export interface IMessage {
    name: string;
    arg?: any;
}
export class MessageBus {
    static trigger(name: string, arg?: any) {
        console.log("Trigger: " + name);
        const m: IMessage = { name: name, arg: arg };
        setTimeout(() => {MessageBus.send(m)},50);
    }
    private static send(message: IMessage) {
        console.log("Trigger: " + message.name);
        MessageBus.handlers.forEach(handler => { handler(message); });
    }
    private static handlers: ((message: IMessage) => void)[] = [];
    static connect(handler: (message: IMessage) => void) {
        console.log("connect: "+(MessageBus.handlers.length+1));
        MessageBus.handlers.push(handler);
    }
    static disconnect(handler: (message: IMessage) => void) {
        console.log("disconnect");
        for (let i = 0; i < MessageBus.handlers.length; i++) {
            if (MessageBus.handlers[i] === handler) {
                console.log("disconnect at index "+i);

                MessageBus.handlers.splice(i, 1);
                i--;
            }
        }
    }
}